
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-41365ba2&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExibirFechamentoExtra.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExibirFechamentoExtra.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-41365ba2!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExibirFechamentoExtra.vue"),
  /* scopeId */
  "data-v-41365ba2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/aplicacaoFechamentoExtra/ExibirFechamentoExtra.vue
// module id = 883
// module chunks = 1